import { Injectable } from "@angular/core";
import { BaseFpxDataService, CreateFn, CriteriaQuery, FindAllFn, FindByKeyFn, HttpProviderService, HttpRequest, LoadForm, LookUpFn, ModifyFn } from "@fpx/core";
import { Observable, of } from "rxjs";
import { UserProfile } from "src/app/models/userProfile.model";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { environment } from "src/environments/environment";
import { Userprofile } from "./userprofile.model";

@Injectable({
    providedIn: 'root'
  })
  export class ProfilepicResultFormService implements BaseFpxDataService<any>{

    constructor(private _httpProvider: HttpProviderService,
    private _processShellService: ProcessShellService ){}

    findByKey(payload: any): FindByKeyFn<any> {
        throw new Error("Method not implemented.");
    }
    findAll(criteriaQuery: CriteriaQuery): FindAllFn<any> {
        throw new Error("Method not implemented.");
    }
    create(payload: any): CreateFn<any> {
        return() =>  of();
    }
    lookup(key: unknown): LookUpFn<any> {
        throw new Error("Method not implemented.");
    }
    modify(payload: any): ModifyFn<any> {
        throw new Error("Method not implemented.");
    }
    uploadPhoto(payload:Userprofile):Observable<any>{
        // const httpRequest = new HttpRequest();
        // httpRequest.setMethod('PUT');
        // httpRequest.setResource('/userprofile{userId}');
        // httpRequest.addPathParameter('userId',userId);
        // //httpRequest.addQueryParameter('documentType', 'PHOTO');
        // // httpRequest.addQueryParameter('ContentType','image/jpg')
        // let bodyContent = payload;
        // httpRequest.setBody(bodyContent);
        // //httpRequest.setServerContext(environment.commonPublisher);
        // return this._httpProvider.invokeRestApi(httpRequest);

            const httpRequest = new HttpRequest();
            httpRequest.setResource('/userprofile/{userId}');
             httpRequest.addPathParameter('userId',payload.userId);
           httpRequest.setMethod('PUT');
            let bodyContent = {"userprofile":payload};
            httpRequest.setBody(bodyContent);
            httpRequest.setServerContext(environment.customersPublisher);
            return this._httpProvider.invokeRestApi(httpRequest);
        }    
  }